import type { InterviewSectionType } from "@repo/app-types/entities/interviewSection/types";
import type { FC } from "react";
import { twMerge } from "tailwind-merge";
import { getInterviewSectionTypeDisplayValues } from "../interviewSections/types.js";

interface LessonItemIconProps {
  type: InterviewSectionType | undefined;
}

/** Displays the lesson type icon with colored background */
export const LessonItemIcon: FC<LessonItemIconProps> = ({ type }) => {
  const { Icon, iconColor } = getInterviewSectionTypeDisplayValues(type);

  return (
    <div
      className={twMerge(
        "flex h-6 w-6 shrink-0 items-center justify-center rounded-lg",
        iconColor,
      )}
    >
      <Icon className="size-4 shrink-0 text-white" />
    </div>
  );
};
